import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { subscribedToAddOnFeature } from "reduxSlices/addOnFeatureSubscriptionsSlice"
import { SURVEY_FEATURE_NAME } from "utils/addOnFeatureHelpers"
import {
  editSurveyScheduledReportExportPath,
  newSurveyReportExportPath,
  newSurveyScheduledReportExportPath,
  surveyReportEditPath,
} from "utils/routeHelpers"
import { SURVEY_REPORT_TYPE } from "utils/reportHelpers"
import ReportsSection from "./ReportsSection"

const SurveyReportsSection = ({ className = "" }) => {
  const surveyFeatureEnabled = useSelector(subscribedToAddOnFeature(SURVEY_FEATURE_NAME))

  if (!surveyFeatureEnabled) return null

  return (
    <ReportsSection
      className={className}
      reportType={SURVEY_REPORT_TYPE}
      editPath={surveyReportEditPath}
      newReportExportPath={newSurveyReportExportPath}
      newScheduledReportExportPath={newSurveyScheduledReportExportPath}
      editScheduledReportExportPath={editSurveyScheduledReportExportPath}
      title="Survey Reports"
    />
  )
}

SurveyReportsSection.propTypes = {
  className: types.string,
}

export default SurveyReportsSection
